import { getToken } from 'services/auth.service';

export const userSelector = state => state.user;

export const isAuthenticatedSelector = state => state.isAuthenticated || false;

export const isExternalPageSelector = state => state.isExternalPage || false;

export const getTokenSelector = state => state?.token || getToken();
